require('./edit.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/payment/payment-module')
require('../components/remote-api/remote-api-module')

# Load Css
require('../../../sass/web/html/_function_setting.scss')

SettingEditCtrl = require('./edit-controller')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-common-wrapper'
  'gnp-error-handler'
  'gnp-payment'
  'gnp-remote-api'
]
angular.module 'gnp-app-setting', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/setting/app',
      templateUrl: 'web/setting/edit.jade'
      controller: 'SettingEditCtrl'
      resolve:
        setting: ['AppSettingAPIService', (AppSettingAPIService) ->
          AppSettingAPIService.getAppSetting()
        ]
      title: '_SETTING.TITLE'
      permission:
        signInRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'SettingEditCtrl', SettingEditCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/setting/setting-module.coffee